import { useEffect, useRef, useState } from 'react';

const ClutchWidget = ({ isLight = false }) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const widgetRef = useRef(null);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://widget.clutch.co/static/js/widget.js"]',
    );

    if (existingScript) return;

    const script = document.createElement('script');
    script.src = 'https://widget.clutch.co/static/js/widget.js';
    script.async = true;
    script.onload = () => {
      setIsScriptLoaded(true);
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!isScriptLoaded || !widgetRef.current) return;

    if (isLight) {
      widgetRef.current.removeAttribute('data-darkbg');
    } else {
      widgetRef.current.setAttribute('data-darkbg', 'darkbg');
    }

    if (window.CLUTCHCO) {
      window.CLUTCHCO.Init();
    }
  }, [isLight, isScriptLoaded]);

  return (
    <div
      key={isLight ? 'clutch-light' : 'clutch-dark'}
      ref={widgetRef}
      className="clutch-widget"
      data-url="https://widget.clutch.co"
      data-widget-type="1"
      data-height="40"
      data-nofollow="true"
      data-expandifr="true"
      data-clutchcompany-id="381822"
      data-darkbg={isLight ? '' : 'darkbg'}
    />
  );
};

export default ClutchWidget;
